// extracted by mini-css-extract-plugin
export default {"copyButtonGroup":"BGgfw","copyButton":"DEGzE","inputWrapper":"hJf69","truncateInput":"IsDYl"};